import { ApiDNIScanResponseScore } from './types/ApiDNIScanResponseScore';
import { DocumentDNIScanScore } from 'modules/ia/models/DocumentDNIScanScore';

export const mapIAScores = (score: ApiDNIScanResponseScore): DocumentDNIScanScore => ({
  address: {
    city: score.address.city,
    country: score.address.country,
    province: score.address.province,
    street: score.address.street,
  },
  birthAddress: {
    firstField: score.birthAddress.firstField,
    secondField: score.birthAddress.secondField,
  },
  birthDate: score.birthDate,
  firstParent: score.firstParent,
  firstSurname: score.firstSurname,
  genre: score.genre,
  idCard: score.idCard,
  name: score.name,
  nationality: score.nationality,
  secondParent: score.secondParent,
  secondSurname: score.secondSurname,
});
